import * as React from 'react';
import { Check } from '@phosphor-icons/react';
import * as SelectPrimitive from '@radix-ui/react-select';

import { cn } from '@/lib/utils';

const SelectItem = React.forwardRef<
    React.ElementRef<typeof SelectPrimitive.Item>,
    React.ComponentPropsWithoutRef<typeof SelectPrimitive.Item>
>(({ className, children, ...props }, ref) => (
    <SelectPrimitive.Item
        ref={ref}
        className={cn(
            'focus:text-accent-foreground relative flex w-full cursor-default select-none justify-between border-b border-solid border-grey-200 px-1 py-[13px] text-2xs font-semibold last:border-b-0 focus:bg-background-secondary data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
            className,
        )}
        {...props}
    >
        <div className="flex-1 pl-2 pr-2">
            <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
        </div>

        <div className="flex justify-end pr-2">
            <SelectPrimitive.ItemIndicator>
                <Check className="h-4 w-4" />
            </SelectPrimitive.ItemIndicator>
        </div>
    </SelectPrimitive.Item>
));
SelectItem.displayName = SelectPrimitive.Item.displayName;

export { SelectItem };
